import { SpriteView } from '../../ui_canvas_engine/SpriteView.ts';
import { Sprites } from '../UIGameImageDictionary.ts';
import { UIGameSpriteHandler } from '../../UIGameSpriteHandler.ts';
export class UIGameMapDiceHighlightView extends SpriteView {
    hide() {
        if (this.parent == undefined) return;
        this.parent.removeChild(this);
    }
    show() {
        if (this.parent != undefined) return;
        this.originalParent.addChild(this);
    }
    constructor(x, y, size, container){
        const inactiveTexture = UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.icon_highlight_square_yellow);
        super(x, y, size, size, container, inactiveTexture);
        this.originalParent = container;
    }
}
